var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.11 122.12"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.06,
    cy: 61.06,
    rx: 60.06,
    ry: 61.06,
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.12 36.76c-5.76 0-10.29 2.07-13.6 6.22-3.3 4.15-4.95 9.88-4.95 17.18s1.59 13.43 4.76 17.35c3.18 3.92 7.77 5.88 13.78 5.88 2.6 0 5.12-.26 7.55-.79 2.43-.53 4.97-1.2 7.6-2.03v8.74c-4.81 1.85-10.27 2.77-16.37 2.77-8.98 0-15.88-2.76-20.69-8.29-4.81-5.53-7.22-13.44-7.22-23.72 0-6.48 1.17-12.15 3.5-17.01 2.34-4.86 5.71-8.58 10.13-11.17 4.42-2.59 9.61-3.88 15.57-3.88 6.27 0 12.06 1.34 17.37 4.01l-3.61 8.48c-2.07-.99-4.26-1.87-6.57-2.62-2.31-.75-4.73-1.13-7.28-1.13z",
    fill: "#fff"
  })));
}
export default SvgC;